import { render, staticRenderFns } from "./ApproveRegister.vue?vue&type=template&id=5f4b3a9c"
import script from "./ApproveRegister.vue?vue&type=script&lang=js"
export * from "./ApproveRegister.vue?vue&type=script&lang=js"
import style0 from "./ApproveRegister.vue?vue&type=style&index=0&id=5f4b3a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports